import template from './estate-header.pug';

export const EstateHeaderComponent = {
  template,
  bindings: {
    records: '<',
    recordStatuses: '<',
    checkedIds: '<',
    totalPages: '<',
    totalCount: '<',
    page: '<',
    afterPageChange: '&',
    onFilterChange: '&',
    onViewChange: '&',
    isModal: '<?',
    filter: '<?',
    isMobile: '<?'
  },
  controller: class EstateHeaderComponent {
    constructor(Estate, RecordStatus, Signal, AlertBox, Table, $stateParams, $async, $log, $rootScope) {
      'ngInject';
      this.Estate = Estate;
      this.AlertBox = AlertBox;
      this.RecordStatus = RecordStatus;
      this.Signal = Signal;
      this.$log = $log;
      this.$rootScope = $rootScope;
      this.$stateParams = $stateParams;
      this.multipleDelete = $async(this.multipleDelete.bind(this));
      this.export = $async(this.export.bind(this));
      this.getRecordStatuses = $async(this.getRecordStatuses.bind(this));
      this.getEstateTypes = $async(this.getEstateTypes.bind(this));
      this.countStatuses = 0;
      this.loader = false;
      this.actionIsVisible = true;
      this.openCharts = false;
      this.Table = Table;
      this.activeFilter = [];
      this.recordStatuses = {};
    }

    $onInit() {

      this.activeTab = 'table';

      if (this.isModal) {
        this.actionIsVisible = false;
      }
      this.getRecordStatuses();
      this.getEstateTypes();
      if (this.$stateParams.statusId) {
        this.selectedStatusId = this.$stateParams.statusId;
      }
      this.Signal.listen('estateStatusChange', this.$rootScope, (statusId) => {
        this.selectedStatusId = statusId;

        if (this.recordStatuses) {
          this.selectedStatus = this.recordStatuses.find(status => status.id === statusId);
        }
      });
    }

    changeTab(tab) {
      this.activeTab = tab;
      this.onViewChange({ $event: { tab } });
    }

    toggleSidebar() {
      this.Signal.send('toggleSideBar', 1);
    }

    async getRecordStatuses() {
      try {
        this.recordStatuses = await this.RecordStatus.getList('estate');
        this.recordStatuses.unshift({ id: -1, title: 'All records', color: '#225268' });
        if (this.selectedStatusId !== undefined) {
          this.selectedStatus = this.recordStatuses.find(status => status.id == this.selectedStatusId);
        } else {
          this.selectedStatus = this.recordStatuses[0];
        }

      } catch (e) {
        this.$log.error(e);
      }
    }

    async getEstateTypes() {
      try {
        this.estateTypes = {};
        const response = await this.Estate.getEstateTypes();
        response.forEach((type) => {
          this.estateTypes[type.id] = type.name;
        });
      } catch (e) {
        this.$log.error(e);
      }
    }

    async multipleDelete() {
      if (!this.alertIfNotSelected()) return;
      try {
        const object = await this.Estate.multipleDeleteModal(this.checkedIds);
        if (object) {
          this.applyFilter({ searchId: this.$stateParams.searchId });
        }
      } catch (e) {
        this.$log.error(e);
      } finally {
        this.loading = false;
      }
    }

    async export() {
      try {
        const response = await this.Estate.export(this.$stateParams.searchId, this.filter);
        if (response) this.AlertBox.addMessage('alert.export_table_success', { type: 'success' });
      } catch (e) {
        this.$log.error(e);
      }
    }

    openAll() {
      if (!this.alertIfNotSelected()) return;
      if (this.checkedIds && this.checkedIds.length > 0) {
        this.checkedIds.forEach((id, i) => {
          window.open('/estates/show/' + id, ''+i);
        });
      }
    }

    applyPage({ page }) {
      this.afterPageChange({
        $event: { page }
      });
    }

    applyFilter({ searchId }) {
      this.onFilterChange({
        $event: { searchId, filter: { ...this.filter, page: 1 } }
      });
    }

    alertIfNotSelected() {
      if (!this.checkedIds.length) {
        this.AlertBox.done('alert.select_at_least_one_record', { type: 'info' });
        return false;
      }
      return true;
    }

  }
};

